import React from 'react';
import PropTypes from 'prop-types';
import Label from '../../Label';

const styles = {
  fontSize: '9px',
  margin: '0 5px',
  display: 'inline-block',
  borderColor: '#eb5424',
  color: '#eb5424'
};

const ContractPickerNoMaster = ({ hasMasterTenant }) => {
  if (hasMasterTenant) {
    return null;
  }

  return <Label style={styles}>No Master</Label>;
};

ContractPickerNoMaster.propTypes = {
  hasMasterTenant: PropTypes.bool
};

export default ContractPickerNoMaster;
